export default __webpack_public_path__ + "static/media/sadFace.653819a9.svg";